import { requestTool } from "../tools";

const post = (url, sendData) => {
    return requestTool.postRequest(url, sendData)

}
const get = (url, sendData) => {
    return requestTool.getRequest(url, sendData)
}
const deleteRequest = (url, sendData) => {
    return requestTool.deleteRequest(url, sendData)
}
const requestService = (url, sendData, method) => {
    return method === "GET" ? get(url, sendData) : post(url, sendData);

}
const postForm = (url,data) => {
    return requestTool.PostRequestByFormData(url, data);
}
const getFileRequest = (url) => {
    return requestTool.getFileRequest(url);
}
export const service = { post, get, deleteRequest, requestService, postForm, getFileRequest };

export default service;

